export const capitalizeFirstLetter = (word)=>{
    return word.charAt(0).toUpperCase() + word.slice(1);
};
export const changeKeyFormat = (obj, format)=>{
    const newObj = {};
    for (const [key, value] of Object.entries(obj)){
        // Apply the specified format to the key
        const newKey = format(key);
        // Assign the value to the new key in the new object
        newObj[newKey] = value;
    }
    return newObj;
};
export const underscoreToCamelCase = (val)=>{
    const words = val.split("_").map((word, index)=>{
        if (index !== 0) {
            return capitalizeFirstLetter(word);
        } else return word;
    });
    return words.join("");
};
